"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  REQUEST_SEAT_UPGRADE: 'requestSeatUpgrade',
  REQUEST_SEAT_UPGRADE_BANNER: 'requestSeatUpgradeBanner',
  REQUEST_ADDITIONAL_SEATS: 'requestAdditionalSeats',
  REQUEST_SEAT_BANNER: 'requestSeatBanner',
  REQUEST_SKU: 'requestSKU',
  REQUEST_TRIAL: 'requestTrial',
  REQUEST_PRODUCT: 'requestProduct',
  REQUEST_QUOTE: 'requestQuote',
  REQUEST_PARTNER: 'requestPartnerScope',
  DEFAULT: 'default'
};
exports.default = _default;
module.exports = exports.default;